export default {
  dashboard: { title: 'Dashboard', url: '/' },
  login: { title: 'Login', url: '/login' },
  'forgot-password': { title: 'Forgot Password', url: '/forgot-password' },
  signup: { title: 'Signup', url: '/signup' },
  logout: { title: 'Logout', url: '/logout' },
  reset: { title: 'Reset', url: '/reset/:param1' },
  contact: { title: 'Contacts', url: '/contact' },
  'contact-add': { title: 'Add Contact', url: '/contact/add' },
  'contact-edit': { title: 'Edit Contact', url: '/contact/edit/:param1' },
  'contact-view': { title: 'Contacts', url: '/contact/:param1' },
  report: { title: 'Reports', url: '/report' },
  'report-view': { title: 'Reports', url: '/report/:param1' },
  'user-profile': { title: 'My Profile', url: '/user/profile' },
  'setting-user': { title: 'Settings', url: '/user' },
  'setting-companyprofile': { title: 'Settings', url: '/user/company' },
  'setting-payment': { title: 'Settings', url: '/user/payment' },
  'setting-integration': { title: 'Settings', url: '/user/integration' },
  'setting-subscription': { title: 'Settings', url: '/user/subscription' },
  'setting-paymentfailed': {
    title: 'Settings',
    url: '/user/paymentfailed/:param1'
  },
  'setting-taxrate': { title: 'Settings', url: '/user/taxrate' },
  'setting-project': { title: 'Settings', url: '/user/project-setting' },
  'setting-demodata': { title: 'Settings', url: '/user/demo-setting' },
  project: { title: 'Project Overview', url: '/project' },
  'projectview-team': { title: 'Projects', url: '/project/team/:param1' },
  'projectview-overview': {
    title: 'Projects',
    url: '/project/overview/:param1'
  },
  'projectview-hour': { title: 'Projects', url: '/project/hour/:param1' },
  'projectview-budget': { title: 'Projects', url: '/project/budget/:param1' },
  'projectview-budgetv2': {
    title: 'Projects',
    url: '/project/budgetv2/:param1'
  },
  estimate: { title: 'Estimates', url: '/estimate' },
  'estimate-view': { title: 'Estimates', url: '/estimate/:param1' },
  time: { title: 'Time', url: '/timesheet' },
  'time-mobile': { title: 'Time', url: '/mobile' },
  expenses: { title: 'Expenses', url: '/expense' },
  purchaseorders: { title: 'Purchase orders', url: '/purchaseorder' },
  'purchaseorder-view': {
    title: 'Purchase Order',
    url: '/purchaseorder/:param1'
  },
  'projectview-planner': { title: 'Projects', url: '/project/planner/:param1' },
  'projectview-task': { title: 'Projects', url: '/project/task/:param1' },
  'console-team': { title: 'Teams', url: '/' },
  'console-teamfilter': { title: 'Teams', url: '/team/:param1' },
  'console-teamview': { title: 'Teams', url: '/team/overview/:param1' },
  invoices: { title: 'Invoices', url: '/invoice' },
  'invoice-template': { title: 'Invoice templates', url: '/invoice/template' },
  'invoice-view': { title: 'Edit invoice', url: '/invoice/:param1' },
  'invoice-template-view': {
    title: 'Edit invoice template',
    url: '/invoice/template/:param1'
  },
  'user-schedule': { title: 'User - Schedule', url: '/user/schedule' },
  'user-schedulev2': { title: 'User - Schedule', url: '/user/schedulev2' },
  'user-absent': { title: 'User - Absent', url: '/user/absent' },
  'user-skills': { title: 'User - Skills', url: '/user/skills' },
  'personal-setting': {
    title: 'Personal - Setting',
    url: '/user/personal-setting'
  },
  task: { title: 'Task', url: '/task' },
  'planned-payment': { title: 'Planned - Payments', url: '/planned-payment' },
  'setting-pdftemplate': { title: 'Settings', url: '/user/pdftemplate' },
  'setting-mailtemplate': { title: 'Settings', url: '/user/mailtemplate' },
  'console-invoice': { title: 'Invoices', url: '/invoice' },
  signupconfirm: { title: 'Signup Confirm', url: '/signup/confirm/:param1' },
  'console-userprofile': { title: 'My Profile', url: '/user/profile' },
  emailconfirm: { title: 'Signup Confirm Email', url: '/emailconfirm' },
  emailunsubscribe: { title: 'Unsubscribe Email', url: '/unsubscribe' },
  tokenexpired: { title: 'Token Expired', url: '/token/expired' },
  'console-profile': { title: 'Profile', url: '/profile' },
  demoimport: { title: 'Demo Import', url: '/demo/import' },
  planner: { title: 'Planner', url: '/planner' },
  plannertask: { title: 'Planner Tasks', url: '/planner/task' },
  chat: { title: 'Chat', url: '/chat' }
}
